import { useContext, useMemo } from "react";
import contextBabylon from "../../../../context/index.js";
import useIsMobile from "../../../device/useIsMobile.js";
export const useDatesInput = (props)=>{
    const { name , disabled , defaultValue , validate , events , enableDates , minDate , maxDate , releaseDays , checkIn , checkOut , enableAllDays , mode ='range' , enableTime , minTime , maxTime , label ='' , disablePrevDays , icon  } = props;
    const { startDateLabel ='' , endDateLabel ='' , modalTitle ='' , modalConfirm ='' , timeModalTitle =''  } = props;
    const { Language  } = useContext(contextBabylon);
    const isMobile = useIsMobile();
    return useMemo(()=>{
        const commonProps = {
            name: name ?? 'dates',
            mode,
            minDate,
            maxDate,
            locale: Language.toLowerCase(),
            monthSelectorType: 'static',
            disabled,
            defaultValue,
            enableDates,
            validate,
            events,
            releaseDays,
            checkIn,
            checkOut,
            enableAllDays,
            enableTime,
            minTime,
            maxTime,
            label,
            disablePrevDays,
            icon
        };
        if (isMobile) {
            return {
                ...commonProps,
                startDateLabel,
                endDateLabel,
                showMonths: 12,
                modalTitle,
                modalConfirm,
                timeModalTitle
            };
        }
        return {
            ...commonProps,
            showMonths: mode === 'range' ? 2 : 1,
            isHiddenRequired: true
        };
    }, [
        Language,
        checkIn,
        checkOut,
        defaultValue,
        disablePrevDays,
        disabled,
        enableAllDays,
        enableDates,
        enableTime,
        endDateLabel,
        events,
        isMobile,
        label,
        maxDate,
        maxTime,
        minDate,
        minTime,
        modalConfirm,
        modalTitle,
        mode,
        name,
        releaseDays,
        startDateLabel,
        timeModalTitle,
        validate,
        icon
    ]);
};
export default useDatesInput;

//# sourceMappingURL=useDatesInput.js.map